import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import SocketProvider from "./context/socket";
import { ErrorBoundary } from "react-error-boundary";
import { HelmetProvider } from "react-helmet-async"; // Import HelmetProvider
import { LangProvider } from "./context/language";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter } from "react-router-dom";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LangProvider>
        <ErrorBoundary fallback={<p>⚠️Something went wrong</p>}>
          <SocketProvider>
            <HelmetProvider>
              <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}
              >
                {/* Wrap your entire app */}
                <App />
              </GoogleOAuthProvider>
            </HelmetProvider>
          </SocketProvider>
        </ErrorBoundary>
      </LangProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
